import {  } from '@reduxjs/toolkit';
import { getSeedsForGrower } from '../Seeds/SeedsActions';
import { clearSeeds } from '../Seeds/SeedsSlice';
import { AppDispatch, RootState } from '../Store';
import { setSelectedGrowerId, clearSelectedPlanIdState } from './UISlice';
import { clearState as ClearFieldPlanState } from '../Plans/FieldPlan/FieldPlanSlice';
import { createTracedAsyncThunk } from '../../../tracing/trace';
import { getAllPlantingRates } from '../Seeds/PlantingRateSlice';
import { clearProductGamePlanV7State } from '../Plans/ProductGamePlanSliceV7';

/**
 * Clears the seeds and their rankings from a previous grower on selecting a new grower, and pulls the newly selected grower's seeds 
 */
export const selectGrowerAndPullSeeds = createTracedAsyncThunk<null, string, { dispatch: AppDispatch; state: RootState; }>(
	'selectGrower/pullSeeds',
	async (context, request, thunkAPI) =>
	{
		try
		{
			// Set the Grower ID
			thunkAPI.dispatch(setSelectedGrowerId(request));

			// Clear the current seeds
			thunkAPI.dispatch(clearSeeds());

			// Get the seeds list and planting rates for the selected grower
			getSeedsAndPlantingRatesForGrower(thunkAPI.dispatch, thunkAPI.getState);

			// Clear any plan data
			thunkAPI.dispatch(ClearFieldPlanState());
			thunkAPI.dispatch(clearSelectedPlanIdState());
			thunkAPI.dispatch(clearProductGamePlanV7State());

			return null;
		}
		catch (e)
		{
			return thunkAPI.rejectWithValue(e);
		}
	}
);

/**
 * These two operations need to be sequenced one after the other so they have their own function. 
 */
async function getSeedsAndPlantingRatesForGrower(dispatch: AppDispatch, getState: () => RootState)
{
	await dispatch(getSeedsForGrower());

	const state = getState();
	if (!state.seeds.series)
		return;

	await getAllPlantingRates(dispatch, state.seeds.series);
}